import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from '../modals/DefaultModal';

const ExcelUploadLoteModal = ({
  show,
  onClose,
  onSuccess,
  dfd,
  dfdLote = null,
  loteNum = null,
}) => {
  const [file, setFile] = useState(null);
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const fileInputRef = useRef(null);
  const token = localStorage.getItem('token');

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const resetModalState = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleUpload = async () => {
    if (!file) {
      showDefaultModal('error', 'Selecione um arquivo para upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('cnpj', dfd.cnpj);
    formData.append(
      'num',
      dfd.num || dfd.dfdNum || (dfdLote && (dfdLote.num || dfdLote.dfdNum))
    );

    if (loteNum !== null && loteNum !== undefined) {
      formData.append('loteNum', loteNum);
    }
    try {
      await axios.post(`${API_BASE_URL.DFD}/importExcelLote`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (onSuccess) onSuccess();
      handleClose();
      // Exibe mensagem após fechar o modal
      setTimeout(() => {
        showDefaultModal('success', 'Planilha importada com sucesso!');
      }, 100);
    } catch (error) {
      console.error('Erro ao enviar o arquivo:', error);
      const errorMessage =
        error.response?.data || error.message || 'Erro ao enviar o arquivo.';
      showDefaultModal('error', errorMessage);
    }
  };

  useEffect(() => {
    if (!show) {
      resetModalState();
    }
  }, [show]);

  const handleClose = () => {
    resetModalState();
    onClose();
  };

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(19, 72, 156) 0%, rgba(19, 72, 156, 1) 100%)',
                padding: '0.35rem 0.75rem',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                  <i className="bi bi-file-earmark-arrow-up me-2" />
                  Importar Planilha Excel - Lote
                </h6>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-link text-white p-0 mb-0"
                    onClick={handleClose}
                    title="Fechar"
                    style={{ fontSize: '1rem', textDecoration: 'none' }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body small">
              <div className="mb-3">
                <label className="form-label fw-semibold mb-2">
                  Selecione o arquivo Excel (.xlsx)
                </label>
                <input
                  type="file"
                  accept=".xlsx"
                  className="form-control form-control-sm"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
                {file && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <i className="bi bi-file-earmark-check me-1" />
                      Arquivo selecionado: <strong>{file.name}</strong>
                    </small>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={handleClose}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={handleUpload}
                disabled={!file}
              >
                <i className="bi bi-upload me-1" />
                Importar
              </button>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
};

export default ExcelUploadLoteModal;
